const reducer = (state, action) => {
  if (action.type === 'CLEAR_CART') {
    return { ...state, cart: [] };
  
  }
  if (action.type === 'REMOVE') {
    return {
      ...state,
      cart: state.cart.filter((cartItem) => cartItem._id !== action.payload),
    };
  }

  if (action.type === 'GET_TOTALS') {
    let { total, qty } = state.cart.reduce(
      (cartTotal, cartItem) => {
        const { productId, qty } = cartItem;
        const itemTotal = productId.price * qty;

        cartTotal.total += itemTotal;
        cartTotal.qty += qty;
        return cartTotal;
      },
      {
        total: 0,
        qty: 0,
      }
    );
    total = parseFloat(total.toFixed(2));
    total = total.toLocaleString('en');
    return { ...state, total, qty };
  }
  if (action.type === 'LOADING') {
    return { ...state, loading: true };
  }
  if (action.type === 'DISPLAY_ITEMS') {
    return { ...state, cart: action.payload, loading: false };
  }
  if (action.type === 'TOGGLE_AMOUNT') {
    let tempCart = state.cart
      .map((cartItem) => {
        if (cartItem._id === action.payload._id) {
          if (action.payload.type === 'inc') {
            return { ...cartItem, qty: cartItem.qty + 1 };
          }
          if (action.payload.type === 'dec') {
            return { ...cartItem, qty: cartItem.qty - 1 };
          }
        }
        return cartItem;
      })
      .filter((cartItem) => cartItem.qty !== 0);
    return { ...state, cart: tempCart };
  }
  throw new Error('no matching action type');
};

export default reducer;
